/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Section from '../components/Section'
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome'

function Contact() {
	return (
		<div className='main-container'>
			<Section className='height-auto'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-7'>
							<h2>Let's get in touch!</h2>
							<p className=''>
								Interested in supporting The Etho on our mission
								to empower marginalised communitites. Or about
								Fair Trade and ethically sourced products? Are
								you interested in retailing in The Etho
								marketplace or have questions about being a
								seller? Perhaps you simply want to say hello!
							</p>
							<p>
								We want to hear from you! Send us a message via
								this form or email and we&apos;ll get back to
								you at our soonest.
							</p>
							<p>
								<a href='mailto:info@theetho.com'>
									<FAI icon={['far', 'envelope']} />
									&nbsp;info@theetho.com
								</a>
							</p>
						</div>
						<div className='col-md-5'>
							<form action='#' method='post'>
								<div className='form-group'>
									<label htmlForm='fullName'>Full Name</label>
									<input
										type='text'
										className='form-control'
										id='fullName'
										placeholder='Morgan Hoffman'
									/>
								</div>
								<div className='form-group'>
									<label htmlForm='email'>Email</label>
									<input
										type='text'
										className='form-control'
										id='email'
										placeholder='morgan.hoffman@email.com'
									/>
								</div>
								<div className='form-group'>
									<label htmlForm='phoneNumber'>
										Phone Number
									</label>
									<input
										type='text'
										className='form-control'
										id='phoneNumber'
										placeholder='(512) 123-4567'
									/>
								</div>
								<div className='form-group'>
									<label htmlFor='message'>Message</label>
									<textarea
										className='form-control'
										id='message'
										rows='10'
										placeholder="What's on your mind?"
									/>
								</div>
								<div className='form-group row'>
									<div className='col-md-4'>
										<button
											type='submit'
											className='btn btn--primary'>
											<span className='btn__text'>
												Submit
											</span>
										</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</Section>
		</div>
	)
}

export default Contact
